// export const technologyTypes =
// {
//     0: "FFF",
//     1: "FGF",
//     2: "Resin"
// }

export enum technologyTypes {
    FFF = 0,
    FGF = 1,
    Resin = 2
}